import axios from 'axios';
export default ({ to, from, next }) => {
    if ((localStorage.getItem('toaomt_token') != null || localStorage.getItem('toaomt_token') != undefined) &&
        (localStorage.getItem('toaomt_role_user') != null || localStorage.getItem('toaomt_role_user') != undefined)) {
        const toaomt_role_user = localStorage.getItem('toaomt_role_user');

        var CryptoJS = require("crypto-js");
        const decryptData = CryptoJS.AES.decrypt(toaomt_role_user, process.env.VUE_APP_CRYPTO_SECRETKEY_key).toString(CryptoJS.enc.Utf8);
        if (decryptData !== process.env.VUE_APP_IS_SALE) {
            localStorage.removeItem('toaomt_token');
            localStorage.removeItem('toaomt_role_user');
            localStorage.removeItem('toaomt_admin');
            window.location.href = "/login";
        } else {
            axios.get(process.env.VUE_APP_API_URL_BACKEND + 'users_permission_sale', {
                headers: {
                    'x-access-token': localStorage.toaomt_token
                }
            })
                .then(res => {

                })
                .catch(err => {
                    window.location.href = "/login";
                    console.error(err);
                })
        }

    } else {
        window.location.href = "/login";
    }

}
